import { type ReactNode } from 'react'
import classNames from 'classnames'
import { Typography } from 'shared/ui'
import styles from '../styles.module.scss'

export const QRCodeContent = ({ value }: { value: ReactNode }) => {
  return (
    <div>
      <div className={classNames(styles.grid, styles.qrcode)}>
        <Typography ariaLabel='QR code' variant='text-input-field' className={styles.label}>
          QR code
        </Typography>
        <div className={styles.content}>{value}</div>
      </div>
    </div>
  )
}
